document.addEventListener('DOMContentLoaded', async () => {
  try {
    /* =================================================
       0. 日本国内配送（海上運賃なし = shipping-table.json 対象外）
       ================================================= */
    const JAPAN_COUNTRY = 'JAPAN';
    const JAPAN_AREAS = [
      'Hokkaido Area',
      'Tohoku Area',
      'Kanto Area',
      'Chubu Area',
      'Hokuriku Area',
      'Kinki Area',
      'Chugoku Area',
      'Shikoku Area',
      'Kyushu Area',
      'Okinawa Area'
    ];
    const JAPAN_NOTE = 'Cross-country delivery is also available.';

    // CIF モーダル側（main-product.liquid）からも同じ値を使う
    window.CIF_JAPAN = {
      country: JAPAN_COUNTRY,
      areas: JAPAN_AREAS,
      note: JAPAN_NOTE
    };

    /* =================================================
       1. FOB 取得
       ================================================= */
    function getUSDPriceFromAnalytics() {
      if (
        typeof ShopifyAnalytics === 'undefined' ||
        !ShopifyAnalytics.meta ||
        !ShopifyAnalytics.meta.product
      ) return null;

      const meta = ShopifyAnalytics.meta;
      const product = meta.product;

      if (product.variants?.length) {
        const selectedId = Number(meta.selectedVariantId);
        const v =
          product.variants.find(v => Number(v.id) === selectedId) ||
          product.variants[0];
        if (v?.price) return Number(v.price) / 100;
      }

      if (product.price) return Number(product.price) / 100;
      if (product.price_min) return Number(product.price_min) / 100;
      return null;
    }

    /* -------------------------------------------------
       FOB を USD で確定させる（2026-09-20 作り直し）

       ShopifyAnalytics が返す価格は「お客様が今見ている通貨」の金額。
       表示通貨が USD だけだった頃は偶然それで合っていたが、
       JPY と NZD を有効化した 2026-09-20 以降は、NZD の金額を USD として
       計算してしまう状態だった（例: 5,965 NZD → $5,965 と誤認）。

       CIF はドル建てで出すので、表示通貨に左右されない
       ストア基準通貨(JPY)の価格を起点にする。
       main-product.liquid が custom.price_fob を渡してくる。
       ------------------------------------------------- */

    // 1円が何通貨になるか。main-product.liquid が shop メタフィールドから渡す。
    const RATES = (() => {
      const r = window.cifCurrencyRates;
      if (r && typeof r === 'object') return r;
      // メタフィールド未設定だと null や空文字が来る。JSON.parse(null) は
      // null を返してしまい、後段の RATES.USD で落ちるので必ず object にする。
      try {
        const parsed = JSON.parse(r);
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch {
        return {};
      }
    })();

    /** JPY 建て価格 → USD。レートが無ければ null。 */
    function resolveFobUSD() {
      const jpy = Number(window.cifProductPriceJPY);
      const jpyToUsd = Number(RATES.USD);
      if (jpy > 0 && jpyToUsd > 0) return jpy * jpyToUsd;

      // メタフィールドが未更新でも、USD で見ている人だけは
      // Shopify.currency.rate がそのまま JPY→USD なので救える。
      const cur = window.Shopify?.currency || {};
      if (jpy > 0 && cur.active === 'USD' && Number(cur.rate) > 0) {
        return jpy * Number(cur.rate);
      }
      return null;
    }

    let productFOB = resolveFobUSD();

    // 上で出せなかったときだけ、従来どおり ShopifyAnalytics を使う。
    // これは「今見ている通貨」の金額なので、USD 表示中しか信用できない。
    if (
      (!productFOB || Number.isNaN(productFOB)) &&
      (window.Shopify?.currency?.active || 'USD') === 'USD'
    ) {
      productFOB = getUSDPriceFromAnalytics();
    }

    if (!productFOB || Number.isNaN(productFOB)) {
      // USD 建ての FOB が確定できない＝正しい CIF が出せない。
      // 間違った金額を見せるより、計算機ごと出さない。
      const box = document.getElementById('cif-calculator');
      if (box) box.style.display = 'none';
      return;
    }

    /* =================================================
       2. M3
       ================================================= */
    // 寸法メタフィールド未登録の車両は M3 が出せないが、
    // 国 / 港は選べるようにして「要問合せ」を出す（フォームごと死なせない）
    const productM3 = Number(window.productM3);
    const hasM3 = !!productM3 && productM3 > 0;

    /* =================================================
       3. shipping-table.json
       ================================================= */
    if (!window.shippingTableUrl) return;
    const res = await fetch(window.shippingTableUrl, { cache: 'no-store' });
    if (!res.ok) return;
    const table = await res.json();

    /* =================================================
       4. Formatter
       ================================================= */

    /* -------------------------------------------------
       表示通貨（2026-09-20 変更）

       CIF/CFR の計算そのものはドル建てで行う。国際取引の慣習であり、
       運賃表 shipping-table.json も USD 建てのため。
       表示だけを、お客様がストアで選んでいる通貨をメインに切り替え、
       残りの通貨を括弧で併記する。
         NZD 選択時: NZ$16,306 ($9,332 USD / ¥1,435,352)
         JPY 選択時: ¥1,435,352 ($9,332 USD / NZ$16,306)
       USD はどの通貨をメインにしても「USD」と明示して、
       ドル建てが基準であることが分かるようにしておく。

       換算は shop メタフィールド custom.currency_rates（1円が何通貨か）を
       使う。商品価格と同じ Shopify のレートなので CIF と商品価格で
       換算がずれない。為替APIを別に叩くとズレるので使わない。

       問い合わせメールに渡す window.lastCIFData は USD のまま。
       社内での金額のやり取りはドル建てに統一しておきたいため。
       ------------------------------------------------- */

    const CURRENCIES = [
      { code: 'USD', symbol: '$', locale: 'en-US' },
      { code: 'JPY', symbol: '¥', locale: 'ja-JP' },
      { code: 'NZD', symbol: 'NZ$', locale: 'en-NZ' },
    ];

    // 1 USD が何円か。RATES が空（メタフィールド未設定）なら null。
    const jpyPerUsd = Number(RATES.USD) > 0 ? 1 / Number(RATES.USD) : null;

    /** USD 金額 → 指定通貨の金額。出せなければ null。 */
    function convertFromUSD(usdAmount, code) {
      if (typeof usdAmount !== 'number' || Number.isNaN(usdAmount)) return null;
      if (code === 'USD') return usdAmount;
      if (!jpyPerUsd) return null;
      const jpyAmount = usdAmount * jpyPerUsd;
      if (code === 'JPY') return jpyAmount;
      const rate = Number(RATES[code]);
      if (!rate || !Number.isFinite(rate)) return null;
      return jpyAmount * rate;
    }

    function formatIn(usdAmount, currency) {
      const value = convertFromUSD(usdAmount, currency.code);
      if (value === null) return null;
      return (
        currency.symbol +
        new Intl.NumberFormat(currency.locale).format(Math.round(value))
      );
    }

    // ストアで選択中の通貨。レートが取れない通貨なら USD のままにする。
    const activeCode = window.Shopify?.currency?.active || 'USD';
    const mainCurrency =
      CURRENCIES.find(
        (c) => c.code === activeCode && convertFromUSD(1, c.code) !== null
      ) || CURRENCIES[0];

    /** 内訳行。メイン通貨だけで出す。 */
    const formatMain = (n) => formatIn(n, mainCurrency) ?? '-';

    /** 合計行。メイン通貨＋残りの通貨を括弧で併記する。 */
    const formatWithAlternatives = (n) => {
      const main = formatIn(n, mainCurrency);
      if (main === null) return '-';

      const parts = [];
      for (const c of CURRENCIES) {
        if (c.code === mainCurrency.code) continue;
        const s = formatIn(n, c);
        if (s === null) continue;
        parts.push(c.code === 'USD' ? `${s} USD` : s);
      }
      return parts.length ? `${main} (${parts.join(' / ')})` : main;
    };

    /* =================================================
       5. UI
       ================================================= */
    const $ = id => document.getElementById(id);

    const countryEl = $('cif-country');
    const portEl = $('cif-port');
    const m3El = $('cif-m3');
    const shippingEl = $('cif-shipping');
    const inspectionEl = $('cif-inspection');
    const insuranceEl = $('cif-insurance');
    const totalEl = $('cif-total');
    const messageEl = $('cif-message');

    const inspectionToggleEl = $('cif-inspection-toggle');
    const insuranceToggleEl = $('cif-insurance-toggle');

    const insuranceValueRow = insuranceEl?.closest('div');
    const totalLabelEl = document.querySelector('.cif-total');
    const noteEl = document.querySelector('.cif-note');

    const cifSummaryEl = totalLabelEl?.closest('.cif-summary');

    if (!countryEl || !portEl || !m3El) return;
    m3El.textContent = hasM3 ? productM3.toFixed(2) : '-';

    const isJapan = () => countryEl.value === JAPAN_COUNTRY;

    // 日本国内配送の案内。エリアを選んだ時点で「計算結果」の位置に出す
    const japanNoteEl = document.createElement('div');
    japanNoteEl.id = 'cif-japan-note';
    japanNoteEl.className = 'cif-japan-note';
    japanNoteEl.textContent = JAPAN_NOTE;

    function updateJapanNote() {
      const japan = isJapan();
      const ready = japan && !!portEl.value;

      japanNoteEl.classList.toggle('is-visible', ready);

      // 日本国内は海上運賃・輸出前検査の対象外なので内訳ごと隠す
      if (cifSummaryEl) cifSummaryEl.style.display = japan ? 'none' : '';
      if (noteEl) noteEl.style.display = japan ? 'none' : '';
      if (japan && inspectionToggleEl) inspectionToggleEl.checked = false;

      window.cifDomesticSelection = ready
        ? { country: countryEl.value, port: portEl.value }
        : null;
    }

    (cifSummaryEl || portEl.parentElement)
      ?.insertAdjacentElement('afterend', japanNoteEl);

    /* =================================================
       6. CIF Tooltip
       ================================================= */
    const cifTooltipIcon = document.createElement('span');
    cifTooltipIcon.textContent = ' ⓘ';
    cifTooltipIcon.style.cursor = 'pointer';
    cifTooltipIcon.style.fontSize = '14px';
    cifTooltipIcon.style.color = '#555';

    const cifTooltipBox = document.createElement('div');
    cifTooltipBox.innerHTML = `
      <strong>CIF (Cost, Insurance and Freight)</strong><br>
      Includes ocean freight and cargo insurance<br>
      to the destination port.
    `;
    Object.assign(cifTooltipBox.style, {
      position: 'absolute',
      background: '#fff',
      border: '1px solid #ddd',
      borderRadius: '6px',
      padding: '10px 12px',
      fontSize: '12px',
      lineHeight: '1.5',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      maxWidth: '260px',
      zIndex: 9999,
      display: 'none'
    });
    document.body.appendChild(cifTooltipBox);

    let tooltipTimer = null;
    const showTooltip = () => {
      clearTimeout(tooltipTimer);
      const r = cifTooltipIcon.getBoundingClientRect();
      cifTooltipBox.style.top = `${r.bottom + window.scrollY + 6}px`;
      cifTooltipBox.style.left = `${r.left + window.scrollX}px`;
      cifTooltipBox.style.display = 'block';
    };
    const hideTooltipDelayed = () => {
      tooltipTimer = setTimeout(() => {
        cifTooltipBox.style.display = 'none';
      }, 200);
    };

    cifTooltipIcon.addEventListener('mouseenter', showTooltip);
    cifTooltipIcon.addEventListener('mouseleave', hideTooltipDelayed);
    cifTooltipBox.addEventListener('mouseenter', showTooltip);
    cifTooltipBox.addEventListener('mouseleave', hideTooltipDelayed);

    /* =================================================
       7. 表示制御（Insurance）
       ================================================= */
    function updateDisplayByInsurance() {
      const isCIF = insuranceToggleEl?.checked;

      if (insuranceValueRow) {
        insuranceValueRow.style.display = isCIF ? 'block' : 'none';
      }

      if (totalLabelEl) {
        totalLabelEl.childNodes[0].textContent =
          isCIF ? 'Estimated CIF: ' : 'Estimated CFR: ';

        if (isCIF && !totalLabelEl.contains(cifTooltipIcon)) {
          totalLabelEl.appendChild(cifTooltipIcon);
        }
        if (!isCIF && totalLabelEl.contains(cifTooltipIcon)) {
          cifTooltipIcon.remove();
          cifTooltipBox.style.display = 'none';
        }
      }

      if (noteEl) {
        noteEl.textContent = isCIF
          ? '* Estimated price. Final CIF may vary.'
          : '* Estimated price. Final CFR may vary.';
      }
    }

    /* =================================================
       8. inspection 初期制御
       ================================================= */
    // 検査必須の港（shipping-table.json の inspection_required）はチェックを外せない。
    // 任意の港は従来どおり、検査料金があれば最初からチェックありで外せる。
    // 必須/任意はクライアントの運賃表（2026-10-13 版）の色分けに従う。
    const inspectionRequiredNote = document.createElement('span');
    inspectionRequiredNote.className = 'cif-inspection-required';
    inspectionRequiredNote.textContent = '(Required for this destination)';
    inspectionRequiredNote.style.cssText = 'font-size:13px; opacity:.75;';
    inspectionRequiredNote.hidden = true;
    inspectionToggleEl?.closest('label')?.appendChild(inspectionRequiredNote);

    function unlockInspection() {
      if (!inspectionToggleEl) return;
      inspectionToggleEl.disabled = false;
      inspectionRequiredNote.hidden = true;
      const label = inspectionToggleEl.closest('label');
      if (label) label.style.cursor = 'pointer';
    }

    function applyInspectionDefault(row) {
      if (!inspectionToggleEl) return;
      const required = !!(row && row.inspection_required);
      inspectionToggleEl.checked = required || !!(row && Number(row.inspection) > 0);
      inspectionToggleEl.disabled = required;
      inspectionRequiredNote.hidden = !required;
      const label = inspectionToggleEl.closest('label');
      if (label) label.style.cursor = required ? 'default' : 'pointer';
    }

    /* =================================================
       9. 初期化
       ================================================= */
    function resetCIF() {
      // 港が決まっていない間だけ必須の固定を解く（チェック状態は従来どおり触らない）。
      // 寸法未登録で金額を出せない場合も、必須港なら固定は残す。
      if (!portEl.value) unlockInspection();
      shippingEl.textContent = '-';
      inspectionEl.textContent = '-';
      insuranceEl.textContent = '-';
      totalEl.textContent = '-';
      if (messageEl) messageEl.style.display = 'none';
      updateDisplayByInsurance();
      updateJapanNote();
      window.lastCIFData = null;
    }

    resetCIF();

    /* =================================================
       10. Country / Port
       ================================================= */
    const countries = [...new Set(table.map(r => r.country))];
    if (!countries.includes(JAPAN_COUNTRY)) {
      const at = countries.findIndex(c => c.localeCompare(JAPAN_COUNTRY) > 0);
      countries.splice(at === -1 ? countries.length : at, 0, JAPAN_COUNTRY);
    }
    countries.forEach(country => {
      const opt = document.createElement('option');
      opt.value = country;
      opt.textContent = country;
      countryEl.appendChild(opt);
    });

    countryEl.addEventListener('change', () => {
      portEl.innerHTML = '<option value="">Select Port</option>';
      resetCIF();

      const ports = isJapan()
        ? JAPAN_AREAS
        : [...new Set(
            table.filter(r => r.country === countryEl.value).map(r => r.port)
          )];

      ports.forEach(port => {
        const opt = document.createElement('option');
        opt.value = port;
        opt.textContent = port;
        portEl.appendChild(opt);
      });
    });

    /* =================================================
       11. 計算
       ================================================= */
    function calculate(rowOverride = null) {
      // 日本国内は海上運賃・輸出前検査の対象外。金額は出さず案内文のみ
      if (isJapan()) {
        resetCIF();
        return;
      }

      const row = rowOverride ||
        table.find(r => r.country === countryEl.value && r.port === portEl.value && r.type === 'M3') ||
        table.find(r => r.country === countryEl.value && r.port === portEl.value && r.type === 'OneSet');

      if (!row) {
        resetCIF();
        if (messageEl) messageEl.style.display = 'block';
        return;
      }

      // M3 課金の航路は体積が必須。寸法未登録なら金額を出さず要問合せ
      // （OneSet は体積に依存しないのでそのまま計算できる）
      if (row.type !== 'OneSet' && !hasM3) {
        resetCIF();
        if (messageEl) messageEl.style.display = 'block';
        return;
      }

      const shipping = row.type === 'OneSet'
        ? Number(row.freight)
        : Math.round(Number(row.freight) * productM3);
      const baseInspection =
        Number(row.inspection) > 0 ? Number(row.inspection) : 350;
      const inspection = inspectionToggleEl?.checked ? baseInspection : 0;
      const insurance = insuranceToggleEl?.checked ? 80 : 0;
      const total = Math.round(
        productFOB + shipping + inspection + insurance
      );

      shippingEl.textContent = formatMain(shipping);
      inspectionEl.textContent = inspection ? formatMain(inspection) : '-';
      insuranceEl.textContent = insurance ? formatMain(insurance) : '-';
      // 合計だけ他通貨を併記する。内訳まで出すと数字が多くなりすぎるため。
      totalEl.textContent = formatWithAlternatives(total);

      updateDisplayByInsurance();

      window.lastCIFData = {
        country: countryEl.value,
        port: portEl.value,
        m3: hasM3 ? productM3.toFixed(2) : 'N/A',
        fob: Math.round(productFOB),
        shipping,
        inspection,
        insurance,
        total
      };
    }

    /* =================================================
       12. Events（計算）
       ================================================= */
    portEl.addEventListener('change', () => {
      if (!countryEl.value || !portEl.value) return;
      if (isJapan()) {
        calculate();
        return;
      }
      const row =
        table.find(r => r.country === countryEl.value && r.port === portEl.value && r.type === 'M3') ||
        table.find(r => r.country === countryEl.value && r.port === portEl.value && r.type === 'OneSet');
      applyInspectionDefault(row);
      calculate(row);
    });

    inspectionToggleEl?.addEventListener('change', () => calculate());
    insuranceToggleEl?.addEventListener('change', () => calculate());

    /* =================================================
       13. ★ ATC 横取り & line item property
       ================================================= */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-form__btn-add-to-cart');
      if (!btn) return;

      if (btn.id === 'holdVehicle' || btn.closest('#holdVehicle')) return;

      const domestic = window.cifDomesticSelection;

      if (!window.lastCIFData && !domestic) {
        // 寸法未登録の車両は算出できないので、購入自体は止めない
        // （従来この JS 自体が起動せず ATC は素通りしていた挙動を維持）
        if (!hasM3) return;

        alert('Please calculate CIF / CFR before adding to cart.');
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      const form =
        btn.closest('form') ||
        document.querySelector('form[action^="/cart/add"]');
      if (!form) return;

      form.querySelectorAll('[data-cif-property]').forEach(el => el.remove());

      const add = (k, v) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = `properties[${k}]`;
        i.value = v;
        i.setAttribute('data-cif-property', '1');
        form.appendChild(i);
      };

      const fmt = (n) => usd.format(Number(n));

      if (domestic) {
        add('Price Type', 'Domestic delivery (Japan)');
        add('Destination Country', domestic.country);
        add('Destination Port', domestic.port);
        add('Volume (m3)', hasM3 ? productM3.toFixed(2) : 'N/A');
        add('FOB USD', `$${fmt(Math.round(productFOB))}`);
        add(
          'Note',
          `${JAPAN_NOTE} Domestic delivery charges are quoted separately.`
        );
        return;
      }

      const d = window.lastCIFData;

      add('Price Type', insuranceToggleEl?.checked ? 'CIF' : 'CFR');
      add('Destination Country', d.country);
      add('Destination Port', d.port);
      add('Volume (m3)', d.m3);

      add('FOB USD', `$${fmt(d.fob)}`);
      add('Shipping USD', `$${fmt(d.shipping)}`);
      add('Inspection USD', `$${fmt(d.inspection)}`);
      add('Insurance USD', `$${fmt(d.insurance)}`);
      add('Estimated Total USD', `$${fmt(d.total)}`);

      add(
        'Note',
        'Shipping charges are estimates and will be invoiced separately.'
      );

    }, true);

  } catch (e) {
    console.error('❌ CIF JS crashed', e);
  }
});